import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Bundles'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Bundles'

export const mediaPlatformBundlesRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.BUNDLES,
  loader: () => ({
    crumb: t('entity:publishing.bundle', { count: 2 }),
  }),
})

export const mediaPlatformBundlesLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformBundlesRoute,
  id: 'mediaPlatformBundlesLayout',
  component: Structure,
})

type MediaPlatformBundlesOverviewSearch = {
  query?: string
}

export const mediaPlatformBundlesOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformBundlesLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformBundlesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
